<template>
  <BaseCard
    class="group relative flex grow cursor-pointer flex-col overflow-hidden p-4"
    type="outlined"
    @click="navigate"
  >
    <TimeAgo class="text-body-medium text-on-surface-variant" :date="survey.createdAt" />
    <div class="flex grow flex-row items-center">
      <div class="flex h-full grow flex-col pr-2">
        <template v-if="survey.title">
          <h3 class="text-title-large">{{ survey.title }}</h3>
          <span class="text-on-surface-variant text-body-medium">
            {{ feedbackTopicTitles }}
          </span>
        </template>
        <template v-else>
          <h3 class="text-title-large line-clamp-3">{{ feedbackTopicTitles }}</h3>
        </template>
      </div>
    </div>
    <div class="flex w-full flex-row justify-end gap-0.5 pt-2">
      <CheckableAvatar
        v-if="selfTandem"
        :member="selfTandem.sender!"
        :is-checked="selfTandem.state == OpenFeedbackState.Completed"
        size="40"
      />
      <CheckableAvatar
        v-for="tandem in peerTandems"
        :key="tandem.sender!.id"
        :member="tandem.sender!"
        :is-checked="tandem.state == OpenFeedbackState.Completed"
        size="40"
      />
      <div
        v-if="externalTandems.length > 0"
        class="bg-secondary-container text-on-secondary-container relative flex h-10 w-10 flex-row items-center justify-center rounded-full"
      >
        <BaseIcon size="20" class="text-on-surface-variant">{{
          iconForPerspective(FeedbackPerspective.External)
        }}</BaseIcon>
        <div
          v-if="false"
          class="bg-tertiary-container text-on-tertiary-container text-label-small absolute -right-0.5 -bottom-0.5 flex h-4 w-4 items-center justify-center rounded-full"
        >
          {{ externalTandems.reduce((acc, prev) => acc + prev.numberOfFeedbacks, 0) }}
        </div>
      </div>
    </div>
    <BaseStateLayer />
  </BaseCard>
</template>
<script setup lang="ts">
  import { computed } from 'vue'
  import BaseStateLayer from '../../../core/components/base/state-layer/BaseStateLayer.vue'
  import TimeAgo from '../../../core/components/base/time-ago/TimeAgo.vue'
  import BaseCard from '../../../core/components/base/card/BaseCard.vue'
  import CheckableAvatar from '../../../core/components/base/avatar/CheckableAvatar.vue'
  import { useRouter } from 'vue-router'
  import type { Survey } from '../../survey/models/survey'
  import { OpenFeedbackState } from '../../open-feedbacks/composables/useOpenFeedbacks'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { useUserStore } from '@/stores/user.store'
  import { FeedbackPerspective, iconForPerspective } from '@/core/models/feedback-perspective'

  interface Props {
    survey: Survey
  }

  const props = defineProps<Props>()

  const router = useRouter()

  const { user } = useUserStore()

  const navigate = () => {
    router.push({ name: 'survey', params: { surveyId: props.survey.templateId } })
  }

  const feedbackTopicTitles = computed(() => {
    return props.survey.feedbackTopics.map((topic) => topic.title).join(', ')
  })

  const selfTandem = computed(() => {
    return props.survey.surveyTandems.find((tandem) => tandem.sender && tandem.sender.id == user.id)
  })

  const peerTandems = computed(() => {
    return props.survey.surveyTandems.filter(
      (tandem) => tandem.sender && tandem.sender.id != user.id,
    )
  })

  const externalTandems = computed(() => {
    return props.survey.surveyTandems.filter((tandem) => tandem.sender === undefined)
  })

  // const members = computed(() => {
  //   return [
  //     ...props.survey.surveyTandems
  //       .flatMap((survey) => [survey.receiver, survey.sender])
  //       .reduce((acc, current) => {
  //         acc.set(current.id, current)
  //         return acc
  //       }, new Map<string, Member>())
  //       .values(),
  //   ]
  // })
</script>
